import { createAction } from '@reduxjs/toolkit';

export const initAction = createAction('audioVideo/initAction');
export const successAction = createAction('audioVideo/successAction');
export const errorAction = createAction('audioVideo/errorAction');
export const resetStateAction = createAction('audioVideo/resetStateAction');

// export const devicesChangedChannelAction = createAction('audioVideo/devicesChangedChannelAction');
// export const canUnmuteChannelAction = createAction('audioVideo/canUnmuteChannelAction');
// export const attendeePresenceChannelAction = createAction(
//   'audioVideo/attendeePresenceChannelAction'
// );
// export const activeSpeakerChannelAction = createAction('audioVideo/activeSpeakerChannelAction');
// export const videoTileChannelAction = createAction('audioVideo/videoTileChannelAction');
export const startWithAudioAction = createAction('audioVideo/setStartWithAudio');
export const startWithVideoAction = createAction('audioVideo/setStartWithVideo');
export const toggleAudioVideoPreviewAction = createAction('audioVideo/toggleAudioVideoPreview');
export const audioVideoTileDidUpdateAction = createAction(
  'audioVideo/audioVideoTileDidUpdateAction'
);
export const audioVideoTileWasRemovedAction = createAction(
  'audioVideo/audioVideoTileWasRemovedAction'
);
export const subscribeToActiveSpeakerDetectorCallbackAction = createAction(
  'audioVideo/subscribeToActiveSpeakerDetectorCallbackAction'
);
export const realtimeSubscribeToVolumeIndicatorCallbackAction = createAction(
  'audioVideo/realtimeSubscribeToVolumeIndicatorCallbackAction'
);
export const realtimeSubscribeToSetCanUnmuteLocalAudioAction = createAction(
  'audioVideo/realtimeSubscribeToSetCanUnmuteLocalAudioAction'
);

export const deviceChangedAction = createAction('audioVideo/deviceChangedAction');
